import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-100 mb-6">
        <i className="ri-emotion-sad-line text-3xl text-foreground-500"></i>
      </div>
      <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
        404
      </h1>
      <p className="text-sm text-foreground-500 mb-6 max-w-md">
        抱歉，您访问的页面不存在。可能已被移除或地址输入有误。
      </p>
      <Link
        to="/"
        className="px-6 py-2.5 whitespace-nowrap rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
      >
        返回首页
      </Link>
    </div>
  );
}